// Bước preview của lệnh sáp nhập (Spec §12.2): hiển thị survivor, absorbed và danh sách con
// trực tiếp của absorbed sẽ được chuyển về survivor. Zero children phải nói rõ, không để trống.

import { Alert, Descriptions } from "antd";
import type { AdminNode } from "../adminTypes";

export function MergeImpactPreview({
  survivor,
  absorbed,
  rehomedChildren,
}: {
  readonly survivor: Pick<AdminNode, "id" | "code" | "name">;
  readonly absorbed: Pick<AdminNode, "id" | "code" | "name">;
  readonly rehomedChildren: readonly Pick<AdminNode, "id" | "code" | "name">[];
}) {
  return (
    <div className="admin-merge-preview" role="status" aria-label="Ảnh hưởng của việc sáp nhập">
      <Alert
        type="warning"
        showIcon
        title={`Toàn bộ quyền hạn, hồ sơ gán và lịch sử của "${absorbed.name}" sẽ dừng hiệu lực từ ngày sáp nhập.`}
      />
      <Descriptions
        size="small"
        column={1}
        items={[
          {
            key: "survivor",
            label: "Đơn vị sống sót",
            children: `${survivor.name} (${survivor.code})`,
          },
          {
            key: "absorbed",
            label: "Đơn vị bị sáp nhập",
            children: `${absorbed.name} (${absorbed.code})`,
          },
          {
            key: "children",
            label: "Con trực tiếp chuyển tiếp quản lý",
            children: (
              <span aria-label={`Chuyển ${rehomedChildren.length} đơn vị con`}>
                {rehomedChildren.length === 0
                  ? "Không có đơn vị con"
                  : rehomedChildren.map((child) => `${child.name} (${child.code})`).join(" · ")}
              </span>
            ),
          },
        ]}
      />
    </div>
  );
}
